
// converts string to number assuming commas are used as thousands separator
// e.g 1,100 => 1100
export default function (value) {
  if (!value) return null
  
  if (typeof value === 'string') {
    return parseFloat(value.replace(/,/g, ''))
  }

  return value

}
